module.exports = __webpack_public_path__ + "01873209fdfc18ec531e7b9bb23431bc.svg";